import { Module } from '@/modules/core/app/constants/app.constants';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { CategoryRoute, CategoryPathName } from '@/modules/ta/category/category.constants';
import { CategoryOverviewRouteConfig } from '@/modules/ta/category/CategoryOverviewRouteConfig';
import { CategoryDataViewsRouteConfig } from '@/modules/ta/category/CategoryDataViewsRouteConfig';

export const router = [
  CategoryOverviewRouteConfig.factory(
    {
      path: `/${CategoryRoute.CATEGORYOVERVIEW}`,
      name: CategoryPathName.CATEGORYOVERVIEW,
      component: () =>
        import(/* webpackChunkName: "categoryoverview-page" */ './pages/CategoryOverviewPage.vue'),
    },
    Module.CATEGORY
  ),
  CategoryOverviewRouteConfig.factory(
    {
      path: `/${CategoryRoute.CATEGORIESOVERVIEW}`,
      name: CategoryPathName.CATEGORIESOVERVIEW,
      redirect: { name: 'categoryoverview' },
    },
    Module.CATEGORY
  ),
  PageRouteConfig.factory(
    {
      path: `/${CategoryRoute.CATEGORIES}`,
      name: CategoryPathName.CATEGORIES,
      component: () =>
        import(/* webpackChunkName: "categories-page" */ './pages/CategoriesPage.vue'),
    },
    Module.CATEGORY
  ),

  PageRouteConfig.factory(
    {
      path: `/${CategoryRoute.CATEGORIES}/new`,
      name: CategoryPathName.CATEGORIESFORM_NEW,
      component: () =>
        import(/* webpackChunkName: "categorydetail-page" */ './pages/CategoryFormPage.vue'),
    },
    Module.CATEGORY
  ),
  PageRouteConfig.factory(
    {
      path: `/${CategoryRoute.CATEGORIES}/:id`,
      name: CategoryPathName.CATEGORIESFORM,
      component: () =>
        import(/* webpackChunkName: "categorydetail-page" */ './pages/CategoryFormPage.vue'),
    },
    Module.CATEGORY
  ),

  CategoryDataViewsRouteConfig.factory(
    {
      path: `/${CategoryRoute.CATEGORIES}/:categoryId/dataviews/:id?`,
      name: CategoryPathName.CATEGORIESDATAVIEWS,
      component: () =>
        import(
          /* webpackChunkName: "categorydataview-page" */ './pages/CategoryDataViewsFormPage.vue'
        ),
    },
    Module.CATEGORY
  ),
  PageRouteConfig.factory(
    {
      path: `/${CategoryRoute.CATEGORIES}/:categoryId/metrics/:id?`,
      name: CategoryPathName.CATEGORIESMETRIC,
      component: () =>
        import(/* webpackChunkName: "categorymetric-page" */ './pages/CategoryMetricFormPage.vue'),
    },
    Module.CATEGORY
  ),
  CategoryOverviewRouteConfig.factory(
    {
      path: `/${CategoryRoute.CATEGORIES}/drilldown/:id/:dataview?/:entityid?`,
      name: CategoryPathName.CATEGORIESDRILLDOWN,
      component: () =>
        import(
          /* webpackChunkName: "categoriesdrilldown-page" */ './pages/CategoryDrilldownPage.vue'
        ),
    },
    Module.CATEGORY
  ),
];
